import { List } from "immutable";
import moment from "moment";
import React from "react";
import * as BS from "react-bootstrap";
import { connect } from "react-redux";
import { Link, RouteComponentProps, withRouter } from "react-router-dom";
import { push } from "react-router-redux";
import * as redux from "redux";
import { JobAlertsForm } from "./components";
import * as Actions from "../../../actions";
import * as Comp from "../../../components";
import { Paths } from "../../../constants";
import { CareerCenterStatuses } from "../../../domain";
import * as M from "../../../models";
import { Api } from "../../../services/Api";
import { AppState } from "../../../store";
import { Utility } from "../../../utils";

const mapStateToProps = (state: AppState, ownProps: OwnProps | undefined): ConnectedState => ({
    api: new Api(state),
    dataLoading: state.careerCenter.loadingResumes,
    resumes: state.careerCenter.userResumes,
});

const mapDispatchToProps = (dispatch: redux.Dispatch<AppState>): ConnectedDispatch => ({
    goto: (url: string) => dispatch(push(url)),
    loadData: () => dispatch(Actions.CareerCenter.loadUserResumes()),
    notifyError: (message: string, icon?: string) => dispatch(Actions.Noti.notifyError(message, icon)),
    notifySuccess: (message: string, icon?: string) => dispatch(Actions.Noti.notifySuccess(message, icon)),
    removeResume: (resume: M.CareerCenter.Resume) => dispatch(Actions.CareerCenter.removeFromUserResumes(resume)),
    toggleLoading: (loading: boolean) => dispatch(Actions.CareerCenter.toggleResumesLoading(loading)),
    replaceHistory: (path: string) => dispatch(Actions.Router.replaceHistory(path)),
});

type OwnProps = RouteComponentProps<{
}> & {
};

interface ConnectedState {
    api: Api;
    dataLoading: boolean;
    resumes: List<M.CareerCenter.Resume>;
}

interface ConnectedDispatch {
    goto: (url: string) => void;
    loadData: () => void;
    notifyError: (message: string, icon?: string) => void;
    notifySuccess: (message: string, icon?: string) => void;
    removeResume: (resume: M.CareerCenter.Resume) => void;
    toggleLoading: (loading: boolean) => void;
    replaceHistory: (path: string) => void;
}

interface OwnState {
    resume?: M.CareerCenter.Resume;
}

type CombinedProps = ConnectedState & ConnectedDispatch & OwnProps;

class UserResumesComponent extends Comp.Base.BaseComponent<CombinedProps, OwnState> {

    private _confirmDelete: Comp.Modal.ConfirmModal | null = null;
    private _confirmRenew: Comp.Modal.ConfirmModal | null = null;

    public constructor(props: any) {
        super(props);
        this.state = {
            loading: false,
        };
    }

    public async componentDidMount() {
        this._isMounted = true;

        await this.props.loadData();
    }

    public componentDidUpdate(prevProps: CombinedProps, prevState: OwnState) {
    }

    public componentWillMount() {
        // get job from state if available
        if (this.props.resumes.size) {
            if (this.props.resumes.size === 1) {
                this.props.replaceHistory(Paths.User.CareerCenter.Resumes + "/" + this.props.resumes.get(0).guid);
                return;
            }
        }
    }

    public componentWillReceiveProps(nextProps: Readonly<CombinedProps>) {
        if (!this.props.resumes.size && nextProps.resumes.size === 1) {
            this.props.replaceHistory(Paths.User.CareerCenter.Resumes + "/" + nextProps.resumes.get(0).guid);
        }
    }

    public componentWillUnmount() {
        this._isMounted = false;
    }

    public render() {
        const items = this.props.resumes.size
            ? <ul className="jobs">
                {this.props.resumes.map((x, i) => {
                    if (!x)
                        return null;

                    return <li key={i}>
                        <Item
                            resume={x}
                            onCopy={() => this.handleOnCopy(x)}
                            onDelete={() => this.toggleDeleteConfirmation(x)}
                            onEdit={() => this.handleOnEdit(x)}
                            onRenew={() => this.toggleRenewConfirmation(x)}
                        />
                    </li>;
                })}
            </ul>
            : null;

        const title = this.props.resumes.size === 1 || this.state.loading ? "Your CV/Resume" : "Your CVs/Resumes";

        return <Comp.Page.PublicPage style={{ position: "relative", minHeight: "200px" }} pageTitle={title}>
                <Comp.Generic.LoadingSpinner show={this.state.loading || this.props.dataLoading} />

                <Comp.Modal.ConfirmModal
                    headerClassName="warning"
                    onProceed={() => this.onDeleteConfirm()}
                    title="Confirm delete"
                    ref={(ref) => this._confirmDelete = ref}
                >
                    <p>Are you sure you want to delete this resume?</p>
                </Comp.Modal.ConfirmModal>

                <Comp.Modal.ConfirmModal
                    headerClassName="info"
                    labelProceed="Renew"
                    onProceed={() => this.onRenewConfirm()}
                    title="Confirm renewal"
                    ref={(ref) => this._confirmRenew = ref}
                >
                    <p>Please confirm you would like to renew this resume.</p>
                </Comp.Modal.ConfirmModal>

                <div id="content-primary">
                    <h1>
                        <Link to={Paths.User.Account}>Your Account</Link> &raquo; {title}
                    </h1>

                    <div className="btn-toolbar">
                        <BS.ButtonGroup>
                            <Link className="btn btn-primary" to={Paths.CareerCenter.Resume.Post}><Comp.Generic.Icon icon="plus" /> Upload new resume</Link>
                        </BS.ButtonGroup>
                    </div>

                    {items}
                </div>

                <div id="content-secondary">
                    <JobAlertsForm />
                </div>
            </Comp.Page.PublicPage>;
    }

    private handleOnCopy(resume?: M.CareerCenter.Resume) {
        if (resume)
            this.props.goto(Paths.CareerCenter.Resume.Post + "?copy=" + resume.guid);
    }

    private handleOnEdit(resume?: M.CareerCenter.Resume) {
        if (resume)
            this.props.goto(Paths.User.CareerCenter.EditResume + "/" + resume.guid);
    }

    private async onDeleteConfirm() {
        if (this._confirmDelete === null)
            return;

        const resume = this._confirmDelete.getRef() as M.CareerCenter.Resume;
        if (resume === undefined) {
            this.props.notifyError("Resume is undefined in the confirmation modal.");
            return;
        }

        const qp = { queryParams: { guid: resume.guid }};
        const result = await this.props.api.delete<boolean>(Api.endpoints.users.careerCenter.resume, qp);

        if (!this._isMounted)
            return;

        if (result.isSuccess) {
            await this.props.removeResume(resume);
            this.props.notifySuccess(`Resume <strong>${resume.title}</strong> has been successfully deleted.`);
        }
        else {
            this.props.notifyError(M.Result.Result.errorsOrMessage(result).join("<br />"));
        }

        if (this._confirmDelete !== null)
            this._confirmDelete.close();
    }

    private async onRenewConfirm() {
        if (this._confirmRenew === null)
            return;

        const resume = this._confirmRenew.getRef() as M.CareerCenter.Resume;
        if (resume === undefined) {
            this.props.notifyError("Resume is undefined in the confirmation modal.");
            return;
        }

        const qp = { queryParams: { guid: resume.guid }};
        const result = await this.props.api.post<M.CareerCenter.Resume>(Api.endpoints.users.careerCenter.renewResume, qp);

        if (!this._isMounted)
            return;

        if (result.isSuccess) {
            await this.props.loadData();
            this.props.notifySuccess(`Resume <strong>${resume.title}</strong> has been successfully renewed.`);
        }
        else {
            this.props.notifyError(M.Result.Result.errorsOrMessage(result).join("<br />"));
        }

        if (this._confirmRenew !== null)
            this._confirmRenew.close();
    }

    private toggleDeleteConfirmation(resume?: M.CareerCenter.Resume) {
        if (resume && this._confirmDelete !== null) {
            this._confirmDelete.show(resume);
        }
    }

    private toggleRenewConfirmation(resume?: M.CareerCenter.Resume) {
        if (resume && this._confirmRenew !== null) {
            this._confirmRenew.show(resume);
        }
    }
}

export const UserResumes: React.ComponentClass<OwnProps> = connect(mapStateToProps, mapDispatchToProps)(withRouter(UserResumesComponent) as any);

interface ItemProps {
    resume: M.CareerCenter.Resume;
    onCopy: () => void;
    onDelete: () => void;
    onEdit: () => void;
    onRenew: (resume: M.CareerCenter.Resume) => void;
}

const Item: React.SFC<ItemProps> = (props) => {
    const now = new Date();
    const resume = props.resume;
    const isDraft = CareerCenterStatuses.isDraft(resume.statusId);
    let expiresOn: Date | undefined;
    let expiredDisplay = null;
    let renewDisplay = null;

    const detailsLink = isDraft
        ? Paths.CareerCenter.Resume.Post + "/" + resume.guid
        : Paths.User.CareerCenter.Resumes + "/" + resume.guid;

    const handleOnRenewClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        props.onRenew(resume);
        e.preventDefault();
        return false;
    };

    if (resume.expiresOn) {
        expiresOn = Utility.utcToLocal(resume.expiresOn);
        if (expiresOn) {
            expiredDisplay = now > expiresOn
                ? <li><strong>Expired {moment(expiresOn).format("MMM D, YYYY")}</strong></li>
                : <li>Expires {moment(expiresOn).format("MMM D, YYYY")}</li>;

            if (now > expiresOn)
                renewDisplay = <li><a href="#" onClick={(e) => handleOnRenewClick(e)}><strong>Renew</strong></a></li>;
        }
    }

    return <Comp.Generic.WrapperLess>
        <h3 className="jobs-title">
            <Link to={detailsLink}>{(isDraft ? "(Draft) " : "") + resume.title}</Link>

            <Comp.Tools.CrudTools
                className="pull-right"
                entity="resume"
                includeCopy
                onCopy={() => props.onCopy()}
                onDelete={() => props.onDelete()}
                onEdit={() => props.onEdit()}
            />
        </h3>

        <ul className="jobs-summary">
            {expiredDisplay}
            {renewDisplay}
        </ul>
    </Comp.Generic.WrapperLess>;
};



// WEBPACK FOOTER //
// ./src/containers/user/careerCenter/UserResumes.tsx